import './Loader.scss';
import { memo } from 'react';
import Fan from '../../../assets/load.png';

interface LoaderProps {
  height?: number;
  width?: number;
  primary?: boolean;
}

/**
 * Primary UI component for user interaction
 */
// eslint-disable-next-line react-refresh/only-export-components
export function Loader({ height, width, primary }: LoaderProps) {
  const imageStyle = {
    height: `${height}px`, // Convert the height prop to pixels
    width: `${width}px`, // Convert the width prop to pixels
  };

  return (
    <div className="loader">
      <div
        className={[
          'spinner',
          `spinner-${primary ? 'active' : 'deactive'}`,
        ].join(' ')}
      >
        <img src={Fan} style={imageStyle} alt="Loading Spinner" />
      </div>
    </div>
  );
}

Loader.defaultProps = {
  height: 50,
  width: 50,
  primary: true,
};

export default memo(Loader);
